import React, { useRef } from "react";
import { Grid, Row, Col, Table, Button, Image } from "react-bootstrap";
import Card from "../Card/Card";
import Modal from "react-modal";
import Zoom from "react-reveal/Zoom";

import imgsrc from "../../images/cart-add-icon.png";
import deletecartIcon from "../../images/delete-cart1.png";
import deletecartAll from "../../images/delete.png";
import refreshImg from "../../images/refresh.png";
import orderImg from "../../images/check.png";
import printerImg from "../../images/printer.png";
import offerImg from "../../images/offers.png";

import TakeOverReceipt from "./TakeOverReceipt";

import { useReactToPrint } from "react-to-print";

const TakeOverComponent = (props) => {
    const {
        state,
        onCat,
        searchInitiate,
        onRadioChanged,
        numberOfItems,
        addToCart,
        onProduct,
        getCart,
        deleteCart,
        onPaytype,
        onOffer,
        onOrderVerify,
        handlePrintAfterBrowserPrint,
        removeFromCart,
        product,
        offer,
        closeModal,
        addons,
        handleAddon,
        checkAddons,
        onhandleOffer,
        onOfferTrigger,
        styles,
    } = props;

    const receiptRef = useRef(null);

    const printReceipt = useReactToPrint({
        content: () => {
            if (!receiptRef.current) {
                console.error("Receipt is not available for printing");
                return null;
            }

            return receiptRef.current;
        },

        onBeforePrint: () => {
            console.log("PRINT STARTED");
        },

        onAfterPrint: () => {
            console.log("PRINT DIALOG CLOSED");

            if (handlePrintAfterBrowserPrint) {
                handlePrintAfterBrowserPrint();
            }
        },

        onPrintError: (errorLocation, error) => {
            console.error(
                "PRINT ERROR:",
                errorLocation,
                error
            );
        },
    });

    const handlePrint = () => {
        if (!state.orderVerified) {
            alert("Please verify the order first");
            return;
        }

        if (state.orderPlaced || state.creatingOrder) {
            return;
        }

        printReceipt();
    };

    const { categories, cart } = state;

    return (
        <div>
            {/* ================= CATEGORIES ================= */}
            <div className="category-bar-wrapper">
                <div className="category-bar">
                    {categories && categories.length > 0 ? (
                        categories.map((category, index) => (
                            <button
                                key={category.id || index}
                                type="button"
                                className={`category-button ${String(category.id) === String(state.catId)
                                    ? "active"
                                    : ""
                                    }`}
                                onClick={() => onCat(category)}
                            >
                                {category.name}
                            </button>
                        ))
                    ) : (
                        <div style={{ padding: "10px" }}>
                            No categories available
                        </div>
                    )}
                </div>
            </div>

            {/* ================= SEARCH ================= */}
            <Grid fluid>
                <Row>
                    {state.search === true && (
                        <Col md={12}>
                            <Card
                                title="Products"
                                ctTableResponsive
                                content={
                                    <div className="search-box">
                                        <input
                                            onChange={(e) =>
                                                searchInitiate(e.target.value)
                                            }
                                            type="search"
                                            placeholder="Enter Product Name..."
                                            className="form-control"
                                            value={state.searchValue}
                                        />
                                    </div>
                                }
                            />
                        </Col>
                    )}
                </Row>
            </Grid>

            <Grid fluid>
                <Row>
                    {/* ================= PRODUCTS ================= */}
                    {(state.catSelected === true ||
                        state.searchValue !== "") && (
                            <Col md={6}>
                                <Card
                                    title="Products"
                                    ctTableResponsive
                                    content={
                                        <Table striped hover>
                                            <tbody>
                                                {state.filteredProducts
                                                    .filter(
                                                        (p) =>
                                                            (p.info.is_deleted === "N" ||
                                                                p.info.status === "1") &&
                                                            p.prices !== null
                                                    )
                                                    .map((prop, key) => (
                                                        <tr key={key}>
                                                            <td>
                                                                {prop.info.food_type === "VEG" && (
                                                                    <i
                                                                        className="fa fa-dot-circle-o"
                                                                        style={styles.green}
                                                                    />
                                                                )}

                                                                {prop.info.food_type ===
                                                                    "NON-VEG" && (
                                                                        <i
                                                                            className="fa fa-dot-circle-o"
                                                                            style={styles.red}
                                                                        />
                                                                    )}
                                                            </td>

                                                            <td style={styles.tdCartLarge}>
                                                                {prop.info.name}
                                                                <br />

                                                                {prop.prices &&
                                                                    prop.prices.length > 1
                                                                    ? prop.prices.map(
                                                                        (price, index) => (
                                                                            <label
                                                                                key={index}
                                                                                style={styles.margin}
                                                                            >
                                                                                <input
                                                                                    type="radio"
                                                                                    style={styles.margin}
                                                                                    name={prop.info.id}
                                                                                    onChange={() =>
                                                                                        onRadioChanged(price)
                                                                                    }
                                                                                />

                                                                                {price.quantity}{" "}
                                                                                {price.measure}{" "}
                                                                                <strong>
                                                                                    {price.offer_price !==
                                                                                        "0"
                                                                                        ? price.offer_price
                                                                                        : price.price}
                                                                                </strong>
                                                                            </label>
                                                                        )
                                                                    )
                                                                    : prop.prices &&
                                                                    prop.prices.map(
                                                                        (price, index) => (
                                                                            <div key={index}>
                                                                                {price.quantity}{" "}
                                                                                {price.measure}{" "}
                                                                                <strong>
                                                                                    {price.offer_price !==
                                                                                        "0"
                                                                                        ? price.offer_price
                                                                                        : price.price}
                                                                                </strong>
                                                                            </div>
                                                                        )
                                                                    )}
                                                            </td>

                                                            <td>
                                                                <select
                                                                    onChange={numberOfItems}
                                                                    defaultValue="1"
                                                                >
                                                                    <option value="1">01</option>
                                                                    <option value="2">02</option>
                                                                    <option value="3">03</option>
                                                                    <option value="4">04</option>
                                                                    <option value="5">05</option>
                                                                </select>
                                                            </td>

                                                            <td>
                                                                <Image
                                                                    src={imgsrc}
                                                                    style={styles.imageMenu}
                                                                    onClick={() =>
                                                                        state.addonStatus === "YES"
                                                                            ? onProduct(prop)
                                                                            : addToCart(prop)
                                                                    }
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    }
                                />
                            </Col>
                        )}

                    {/* ================= CART ================= */}
                    {state.proSelected === true && (
                        <Col md={6}>
                            <div>
                                <Image
                                    onClick={getCart}
                                    src={refreshImg}
                                    style={styles.marginAll10}
                                />

                                <Image
                                    onClick={deleteCart}
                                    src={deletecartAll}
                                    style={styles.marginAll10}
                                />

                                {/* PAYMENT */}
                                <label style={styles.margin}>
                                    <input
                                        type="radio"
                                        name="pay"
                                        value="cash"
                                        checked={state.pay === "cash"}
                                        onChange={onPaytype}
                                    />
                                    <span>&nbsp; Cash</span>
                                </label>

                                <label>
                                    <input
                                        type="radio"
                                        name="pay"
                                        value="online"
                                        checked={state.pay === "online"}
                                        onChange={onPaytype}
                                    />
                                    <span>&nbsp; Online</span>
                                </label>

                                <label>
                                    <input
                                        type="radio"
                                        name="pay"
                                        value="swipe"
                                        checked={state.pay === "swipe"}
                                        onChange={onPaytype}
                                    />
                                    <span>&nbsp; Swipe</span>
                                </label>

                                <Image
                                    onClick={onOffer}
                                    src={offerImg}
                                    style={styles.imgSmall}
                                />

                                {/* VERIFY */}
                                {!state.orderPlaced && (
                                    <Image
                                        onClick={onOrderVerify}
                                        src={orderImg}
                                        style={styles.imgSmall}
                                    />
                                )}

                                {/* PRINT */}
                                {state.orderVerified &&
                                    !state.orderPlaced &&
                                    !state.creatingOrder && (
                                        <Image
                                            onClick={handlePrint}
                                            src={printerImg}
                                            style={styles.imgSmall}
                                        />
                                    )}
                            </div>

                            {/* TOTAL */}
                            <div className="numbers">
                                {state.cartPrice && (
                                    <div className="form-group">
                                        <span style={{ fontSize: "20px" }}>
                                            Total:{" "}
                                            {Math.round(
                                                Number(state.cartPrice.cartTotal || 0)
                                            )}
                                        </span>

                                        {state.pay === "cash" && (
                                            <>
                                                <input
                                                    size="8"
                                                    type="text"
                                                    name="amount"
                                                    onChange={props.onFieldChange}
                                                    placeholder="amount"
                                                    style={{
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                    }}
                                                />

                                                <input
                                                    size="6"
                                                    type="text"
                                                    name="change"
                                                    value={
                                                        state.amount === ""
                                                            ? ""
                                                            : Number(state.amount) -
                                                            Math.round(
                                                                state.cartPrice
                                                                    .cartTotal || 0
                                                            )
                                                    }
                                                    readOnly
                                                    placeholder="change"
                                                    style={{
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                    }}
                                                />
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* CART TABLE */}
                            <Card
                                title="Cart"
                                ctTableResponsive
                                content={
                                    <Table striped hover>
                                        <tbody>
                                            {(cart || []).map((item, index) => (
                                                <tr key={index}>
                                                    <td style={styles.tdCartLarge}>
                                                        {item.name}
                                                    </td>

                                                    <td style={styles.tdCart}>
                                                        {item.quantity} Qty
                                                        <br />
                                                        ₹ {item.cartTotal}
                                                    </td>

                                                    <td style={styles.tdSmall}>
                                                        <Image
                                                            src={deletecartIcon}
                                                            style={styles.imgSmall}
                                                            onClick={() =>
                                                                removeFromCart(item)
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                }
                            />

                            {/* ================= RECEIPT PREVIEW ================= */}
                            {state.orderVerified && state.showPrintPreview && (
                                <div
                                    style={{
                                        background: "#fff",
                                        padding: "10px",
                                    }}
                                >
                                    <TakeOverReceipt
                                        ref={receiptRef}
                                        storeName={props.storeName}
                                        storeAddress={props.storeAddress}
                                        gst={props.gst}
                                        billNo={state.bill_no}
                                        totalOrders={state.totalOrders}
                                        date={state.date}
                                        cart={state.cart}
                                        products={state.products}
                                        cartPrice={state.cartPrice}
                                        categories={categories}
                                    />
                                </div>
                            )}
                        </Col>
                    )}
                </Row>
            </Grid>

            {/* ================= ADDON MODAL ================= */}
            {product && (
                <Modal
                    isOpen={true}
                    onRequestClose={closeModal}
                    ariaHideApp={false}
                    className="Modal"
                >
                    <Zoom>
                        <Card
                            title={product.info.name}
                            content={
                                <>
                                    <div className="modal-header">
                                        <Button
                                            bsStyle="info"
                                            onClick={() => addToCart(product)}
                                        >
                                            Skip
                                        </Button>

                                        &nbsp;&nbsp;

                                        <Button
                                            bsStyle="info"
                                            onClick={() => checkAddons(product)}
                                        >
                                            Add n continue
                                        </Button>
                                    </div>

                                    <table className="table">
                                        <tbody>
                                            {(addons || []).map((addon, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            onChange={() =>
                                                                handleAddon(addon, product)
                                                            }
                                                        />
                                                    </td>

                                                    <td>
                                                        <strong>{addon.name}</strong>
                                                    </td>

                                                    <td>{addon.food_type}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            }
                        />
                    </Zoom>
                </Modal>
            )}

            {/* ================= OFFER MODAL ================= */}
            {offer && (
                <Modal
                    isOpen={true}
                    onRequestClose={closeModal}
                    ariaHideApp={false}
                    className="Modal"
                >
                    <Zoom>
                        <Card
                            content={
                                <>
                                    <Button
                                        bsStyle="info"
                                        onClick={closeModal}
                                    >
                                        Skip
                                    </Button>

                                    &nbsp;&nbsp;

                                    <Button
                                        bsStyle="info"
                                        onClick={onhandleOffer}
                                    >
                                        Apply and continue
                                    </Button>

                                    <table className="table">
                                        <tbody>
                                            {(state.offers || []).map(
                                                (item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <input
                                                                type="radio"
                                                                name="offer"
                                                                onChange={() =>
                                                                    onOfferTrigger(item)
                                                                }
                                                            />
                                                        </td>

                                                        <td>
                                                            <strong>{item.title}</strong>
                                                        </td>

                                                        <td>{item.description}</td>

                                                        <td>
                                                            {item.offer_percentage}%
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </>
                            }
                        />
                    </Zoom>
                </Modal>
            )}
        </div>
    );
};
export default TakeOverComponent;